/**********************************************************************************
 *
 * Folder Forager Building Hook
 *
 * Author:         Robert Bleeks
 * Date:           July 2026
 *
 **********************************************************************************/

import {useState, useEffect} from "react";
import {functions} from "../../../constants/common-functions";

export default function useFolderForagerBuilding(buildingId, buildingCode)
{
    const [loading,
           setLoading] =
        useState(false);

    const [directories,
           setDirectories] =
        useState([]);

    const [selectedDirectory,
           setSelectedDirectory] =
        useState(null);

    const [documents,
           setDocuments] =
        useState([]);

    const [selectedDocument,
           setSelectedDocument] =
        useState(null);


    /*****************************************************
     *
     * Load Root Directories
     *
     *****************************************************/

    function loadRootDirectories()
    {
        if(buildingId == null)
        {
            setDirectories([]);
            return;
        }

        setLoading(true);
		
        functions.getArrayFromAjax(

            "/resolutionsoftwareplatform/folderforager/directoriesforbuilding" +
            "?buildingId=" + buildingId,

            function(data)
            {
				
                setDirectories(

                    data.map(directory => ({

                        ...directory,

                        expanded: false,

                        loaded: false,

                        children: []

                    }))

                );
				
                setLoading(false);
            },

            null

        );
    }


    /*****************************************************
     *
     * Expand Directory
     *
     *****************************************************/

    function expandDirectory(directory)
    {
        directory.expanded = !directory.expanded;

        setDirectories([...directories]);

        if(directory.expanded && !directory.loaded)
        {
            loadChildDirectories(directory);
        }
    }


    /*****************************************************
     *
     * Load Child Directories
     *
     *****************************************************/

    function loadChildDirectories(directory)
    {
        functions.getArrayFromAjax(

            "/resolutionsoftwareplatform/folderforager/childdirectoriesforbuilding" +
            "?buildingId=" + buildingId +
            "&parentId=" + directory.id + 
			"&buildingCode=" + buildingCode,

            function(data)
            {
                directory.children =

                    data.map(child => ({

                        ...child,

                        expanded: false,

                        loaded: false,

                        children: []

                    }));

                directory.loaded = true;

                setDirectories([...directories]);
            },

            null

        );
    }


    /*****************************************************
     *
     * Select Directory
     *
     *****************************************************/

    function selectDirectory(directory)
    {
        setSelectedDirectory(directory);

        functions.getArrayFromAjax(

            "/resolutionsoftwareplatform/folderforager/documentsforbuilding" +
            "?buildingId=" + buildingId +
            "&directoryId=" + directory.id + 
			"&buildingCode=" + buildingCode,

            setDocuments,

            null

        );
    }


    /*****************************************************
     *
     * Select Document
     *
     *****************************************************/

    function selectDocument(document)
    {
        setSelectedDocument(document);
    }


    /*****************************************************
     *
     * Initial Load
     *
     *****************************************************/

    useEffect(

        function()
        {
            loadRootDirectories();
        },

        [buildingId]

    );


    return {

        loading,

        directories,

        selectedDirectory,

        documents,

        selectedDocument,

        setSelectedDocument,

        expandDirectory,

        selectDirectory,

        selectDocument

    };
}